import { useNavigate } from 'react-router-dom'
import routerUrls from '../constants/routeUrlConstants'
import { useIsAuthenticated } from '@azure/msal-react'

export const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated()
  const userInfo = window.sessionStorage.getItem('userInfo')

  const navigate = useNavigate()
  if (!userInfo && !isAuthenticated) {
    navigate(routerUrls.HOME.path)
    return
  }
  return children
}
